<template>
	<div class="pr_chinese">
		<div class="pp_pc" v-if="!isPhone">
			<div class="sort_con">
				<div class="sort_list bgimg1 flex3">
					<div data-aos="fade-up" class="item_box" v-for="(item, index) in proList" :key="index">
						<div class="sort_item">
							<div class="con_p1 flex1">
								<div class="con_p1_left">
									<img :src="staticImg + item.image" />
								</div>
								<span class="con_p1_right">系列</span>
							</div>
							<p class="con_p2">{{ item.summary }}</p>
							<div class="con_p3">
								<span @click="toProductList(item.id)">查看详情</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<record></record>
		</div>
		<div class="pp_phone" v-if="isPhone">
			<Header2 :searchShow="false" pageTitle="产品中心"></Header2>
			<div class="sp_box1">
				<swiper class="swiper_box" :options="swiperOption" ref="mySwiper">
					<swiper-slide class="slid_item">
						<img src="@/images/productCenter/phimg2.png" />
					</swiper-slide>
					<swiper-slide class="slid_item">
						<img src="@/images/productCenter/phimg1.png" />
					</swiper-slide>
					<div class="swiper-pagination" slot="pagination"></div>
				</swiper>
			</div>
			<div class="sort_list bgimg1">
				<div class="item_box" v-for="(item, index) in proList" :key="index" @click="toProductList(item.id)">
					<div class="sort_item">
						<div class="con_p1">
							<div class="con_p1_left">
								<img :src="staticImg + item.image" />
							</div>
							<p class="con_p1_right">系列</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			proList: [],
			staticImg: this.$staticImg + "/",
			isPhone: this.$isMobile,
			swiperOption: {
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				},
				autoplay: true,
				mousewheel: true,
				speed: 1000, //切换速度
			},
		}
	},
	created() {
		this.product();
	},
	methods: {
		toProductList(id) {
			this.$router.push("/productList?xlid=" + id + "&type=2");
		},
		// 产品系列
		async product() {
			const res = await this.$api.product();
			if (res.code == 1) {
				this.proList = res.data;
			}
		},
	},
}
</script>

<style lang="scss">
.pr_chinese {
    @font-face {
        font-family: 'SourceHanSans';
        src: url('../../font/SourceHanSansCN-Regular.otf');
    }
    font-family: 'SourceHanSans';
	.pp_pc {
		margin-top: 76px;
		padding: 52px 0 85px 0;
		background-image: url("../../images/bgimg3.png");
		.sort_con {
			width: 100%;
			margin-bottom: 90px;
			.sort_list {
				max-width: 1460px;
				min-width: 950px;
				margin: 0 auto;
				flex-wrap: wrap;
				.item_box {
					width: 33.3%;
					padding: 0 20px;
					margin-bottom: 36px;
					box-sizing: border-box;
					.sort_item {
						box-sizing: border-box;
						padding: 56px 56px 34px;
						background-image: url("../../images/bgimg2.png");
						background-size: 100% 100%;
						.con_p1 {
							height: 91px;
							border-bottom: 1px solid #dcdcdc;
							padding-bottom: 16px;
							margin-bottom: 30px;
							.con_p1_left {
								flex: 1;
								img {
									display: inline-block;
									margin-right: 5px;
									vertical-align: sub;
									max-width: 85%;
									max-height: 90%;
									vertical-align: middle;
								}
							}
							.con_p1_right {
								color: #666;
								font-size: 24px;
								width: 50px;
								flex-shrink: 0;
								font-family: SimSun !important;
								font-weight: 700;
							}
						}
						.con_p2 {
							font-size: 18px;
							height: 114px;
							line-height: 1.7;
							color: #444;
							text-align: left;
						}
						.con_p3 {
							width: 153px;
							height: 45px;
							line-height: 45px;
							text-align: center;
							background-image: url("../../images/productCenter/bg11.png");
							background-repeat: no-repeat;
							background-position: 50%;
							margin: 26px auto 0;
							font-size: 17px;
							cursor: pointer;
							span:hover {
								color: #cc0000;
							}
						}
					}
				}
			}
		}
	}
	@media screen and (max-width: 1580px) {
		.pp_pc {
			.sort_con {
				.sort_list {
					.item_box {
						.sort_item {
							padding: 40px 30px;
							.con_p2 {
								font-size: 16px;
								overflow: hidden;
							}
						}
					}
				}
			}
		}
	}
	.pp_phone {
		background-image: url("../../images/bgimg3.png");
		padding: 1.23rem 0 2rem 0;
		.sp_box1 {
			.swiper_box {
				.slid_item {
					img {
						width: 100%;
					}
				}
				.swiper-pagination-bullet-active {
					background: #fff !important;
				}
			}
		}
		.sort_list {
			padding: 0.35rem 0.36rem;
			box-sizing: border-box;
			.item_box {
				padding: 0 0.213rem;
				display: inline-block;
				width: 33.3%;
				margin-bottom: 0.32rem;
				box-sizing: border-box;
				.sort_item {
					border: 1px solid #d1d1d1;
					border-radius: 4px;
					background-color: #fff;
					padding: 0.467rem 0.187rem 0.4rem;
					box-sizing: border-box;
					.con_p1_left {
						height: 0.88rem;
						line-height: 0.88rem;
						text-align: center;
						margin-bottom: 0.15rem;
						img {
							max-height: 90%;
							max-width: 100%;
						}
					}
					.con_p1_right {
						text-align: center;
						color: #666;
						font-size: 10px;
						font-weight: 700;
					}
				}
			}
		}
	}
}
</style>